import { render, staticRenderFns } from "./helpCenter.vue?vue&type=template&id=304afc71&scoped=true"
import script from "./helpCenter.vue?vue&type=script&lang=js"
export * from "./helpCenter.vue?vue&type=script&lang=js"
import style0 from "./helpCenter.vue?vue&type=style&index=0&id=304afc71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304afc71",
  null
  
)

export default component.exports